// extracted by mini-css-extract-plugin
export var orderSummary = "_my-0";
export var showMoreLessButton = "_my-1";